import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20overlapping%20geometric%20shapes%20in%20golden%20and%20amber%20tones%2C%20smooth%20flowing%20textures%2C%20luxurious%20elegant%20atmosphere%2C%20minimalist%20art%20composition&width=1600&height=600&seq=cta-bg-2025-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/80 via-secondary-800/70 to-secondary-900/80"></div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white font-heading mb-4">
          还没找到适合你的看片网站？
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 leading-relaxed">
          浏览我们的完整测评库，根据你的偏好筛选最适合的在线观影平台。免费、付费、高清、海外——总有一款适合你。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/free-platforms"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full bg-white/10 backdrop-blur-sm text-white border border-white/20 font-semibold text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}